import { LoaderService } from './../../../core/services/loader/loader.service';
import { NavigationService } from './../../../core/services/navigation/navigation.service';
import { LocalStorageService } from './../../../core/services/localStorage/localStorage.service';
import { Component, OnInit } from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    Validators,
} from '@angular/forms';
import { CustomizerSettingsService } from 'src/app/components/customizer-settings/customizer-settings.service';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';
import { LoginResponse } from 'src/app/core/interfaces/authentication/authentication.interface';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CookieService } from 'src/app/core/services/cookie/cookie.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
    hide = true;
    public loginForm!: FormGroup;
    public AuthenticationRoutes = urlRoutes;

    constructor(
        public themeService: CustomizerSettingsService,
        private authenticationService: AuthenticationService,
        public formBuilder: FormBuilder,
        private localStorageService: LocalStorageService,
        private navigationService: NavigationService,
        private toasterService: ToasterService,
        private loaderService: LoaderService,
        private route: ActivatedRoute,
        private cookieService: CookieService  
    ) { }

    ngOnInit(): void {
        this.createLoginForm();
    }

    public get f() {
        return this.loginForm.controls;
    }

    // private createLoginForm(): void {
    //     this.loginForm = this.formBuilder.group({
    //         email: [null, [Validators.required, Validators.email]],
    //         password: [null,[Validators.required, Validators.pattern(
    //             /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/
    //           ),],],
    //         twoFactorAuthCode:[null],
    //         remember: [null],
    //     });
    // }

    private createLoginForm(): void {
        this.loginForm = this.formBuilder.group({
            email: [null, [Validators.required, Validators.email]],
            password: [null, [Validators.required]],
            twoFactorAuthCode: [null],
            remember: [null],
        });
    }

    public showFieldError(field: AbstractControl): boolean {
        return field.invalid && (field.dirty || field.touched);
    }

    public toggleTheme(): void {
        this.themeService.toggleTheme();
    }

    public toggleCardBorderTheme(): void {
        this.themeService.toggleCardBorderTheme();
    }

    public toggleCardBorderRadiusTheme(): void {
        this.themeService.toggleCardBorderRadiusTheme();
    }

    public toggleRTLEnabledTheme(): void {
        this.themeService.toggleRTLEnabledTheme();
    }

    public onSubmit(): void {
        if (this.loginForm.invalid) {
            return;
        }
        this.loaderService.showLoader();
        const formValues = this.loginForm.getRawValue();
        const payload = {
            email: formValues.email,
            password: formValues.password,
            security: formValues.twoFactorAuthCode,
            remember: formValues.remember,
            currentVersion: environment.APP_VERSION
        };
        const returnUrl = this.route.snapshot.queryParams['returnUrl'];
        const selectedDomainMails = localStorage.getItem('selected_domain_mails');
        localStorage.clear();
        this.authenticationService.login(payload).subscribe(
            (res: LoginResponse) => {
                this.loaderService.hideLoader();
                if (res.statusCode === 200 && res.data?.token) {
                    const userData: any = res?.data;
                    const token = userData?.token;
                    this.cookieService.setCookie('ref_token', userData?.refreshToken, 1);
                    delete userData?.refreshToken;
                    // this.localStorageService.setKey('access_token', token);
                    this.getAccessToken(userData, returnUrl, selectedDomainMails);  
                    // this.navigationService.routeToPath(redirectRoute);
                }else{
                    const message: string = res.data as any;
                    this.toasterService.showError('Login Failed', message);
                }
            },
            (err) => {
                this.loaderService.hideLoader();
                console.log(err);
            }
        );
    }

    trimEmail() {
        const emailControl = this.loginForm.get('email');
        if (emailControl) {
            const trimmedValue = emailControl.value.trim();
            emailControl?.setValue(trimmedValue, { emitEvent: false });
        }
    }

    getAccessToken(userData, returnUrl, selectedDomainMails) {
        this.authenticationService.getAccessToken(this.cookieService.getCookie('ref_token')).subscribe(
        (res: any) => {
            if (res.statusCode === 200) {
                console.log(res);
                const token = res?.data?.accessToken;
                this.localStorageService.setKey('access_token',token);
                this.postLoginActions(userData, returnUrl, selectedDomainMails);
            }
            const message: string = res.data as any;
        });
    }

    postLoginActions(userData, returnUrl, selectedDomainMails) {
        const redirectRoute = `/${this.AuthenticationRoutes.mainLayout}`;
        this.localStorageService.setKey('user_details', JSON.stringify(userData));
        this.localStorageService.setKey('roles_permissions', JSON.stringify(userData?.roles));
        if (userData?.accountAccess && userData?.accountAccess.length > 0) {
            this.localStorageService.setKey('accountAccess', JSON.stringify(userData?.accountAccess));
        }
        if (returnUrl) {                        
            if (selectedDomainMails) {
                localStorage.setItem('selected_domain_mails', selectedDomainMails);
            }
            this.navigationService.routeToPath(returnUrl, { replaceUrl: true });
        } else {
            this.navigationService.routeToPath(redirectRoute);
        }
        return;
    }
}
